import { SbChurchSchema } from "@storyblok/types/287435740670216/storyblok-components";
import { generateChurchSchema } from "@jesus-central-church/schema-org";

export function ChurchSchemaComponent({ blok }: { blok: SbChurchSchema }) {
  const schema = generateChurchSchema({
    name: blok.name,
    url: blok.url.url,
    address: {
      streetAddress: blok.streetAddress,
      postalCode: blok.postalCode,
      addressCountry: blok.addressCountry,
      addressLocality: blok.addressLocality,
      "@type": "PostalAddress",
    },
    telephone: blok.telephone,
    image: {
      url: blok.image.filename!,
      width: "1200",
      height: "630",
      caption: blok.image.alt!,
      "@type": "ImageObject",
    },
  });

  return (
    <script
      id={"church-schema-" + blok._uid}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema).replaceAll('<', String.raw`\u003c`),
      }
      }
    />
  );
}